/**
 * This file is categorized as "Proprietary Framework Code"
 * and is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */
import { useState, useEffect, useRef, } from 'react';
import {
	Column,
	Modal,
} from 'native-base';
import * as Progress from 'react-native-progress';
import withRedux from '../data/hoc/withRedux';
import getIsMobile from '../functions/getIsMobile';


let progressTimeout = null;

function ProgressModal(props) {
	const {
			progressMessage,
			progressPercentage,
		} = props,
		isMobile = getIsMobile(),
		[showModal, setShowModal] = useState(false),
		[progressBarWidth, setProgressBarWidth] = useState(175),
		progressBarPoints = useRef(0);

	useEffect(() => {
		setShowModal(progressPercentage !== 100);
		if (progressPercentage === 100) {
			clearTimeout(progressTimeout);
			progressTimeout = setTimeout(() => {
				if (isMobile) {
					// TODO: Modal doesn't close in debug mode unless console.log below executes!
					console.log('hide modal');
				}
				setShowModal(false);
			}, 1000);
		}
	}, [progressPercentage]);

	return <Modal isOpen={showModal} useNativeDriver={false}>
				<Modal.Content maxWidth="400px">
					<Modal.Header>{progressMessage}</Modal.Header>
					<Modal.Body>
						<Column
							flex={1}
							justifyContent="center"
							alignItems="center"
							onLayout={(e) => {
								setProgressBarWidth(e.nativeEvent.layout.width);
							}}
						>
							<Progress.Bar
								animated={false}
								progress={progressPercentage / 100}
								width={progressBarWidth}
								height={20}
								color="#005487"
							/>
						</Column>
					</Modal.Body>
				</Modal.Content>
			</Modal>;
}

export default withRedux(ProgressModal, [
	'relogin',
	'progressMessage',
	'progressPercentage',
]);